import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import { getDatabaseTree } from "./operations.js";

const databaseSlice = createSlice({
    name: "database",
    initialState: initialState.database,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(getDatabaseTree.pending, state => {
            state.error = null;
          })
          .addCase(getDatabaseTree.fulfilled, (state, action) => {
            state.databaseTree = action.payload;
            state.error = null;
          })
          .addCase(getDatabaseTree.rejected, (state, action) => {
            state.error = action.payload;
          });
    }
});

export default databaseSlice.reducer;